import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "../../lib/api";

const FIELDS = [
  ["bank", "Bank", "e.g. Westpac"],
  ["account_name", "Account name", "e.g. J C & Sons Ltd"],
  ["account_number", "Account number", "00-0000-0000000-00"],
];

export const PaymentSettings = () => {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    http.get("/settings/payment").then((r) => setForm(r.data ?? {})).catch(() => setForm({}));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.put("/admin/settings/payment", form);
      setForm(data);
      toast.success("Payment details saved");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (!form) return <Loader2 className="mt-10 h-6 w-6 animate-spin text-[var(--gold)]" />;
  return (
    <form onSubmit={save} className="mt-8 max-w-xl rounded-3xl border border-white/10 bg-[#161D17] p-6 sm:p-8" data-testid="payment-settings-form">
      <p className="text-[var(--sage)]">These details show on the order confirmation screen and in every payment email. Changes apply to new orders straight away.</p>
      <div className="mt-6 grid gap-5">
        {FIELDS.map(([k, label, ph]) => (
          <label key={k} className="block">
            <span className="mb-2 block font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--sage)]">{label}</span>
            <input value={form[k] ?? ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} placeholder={ph} required className="field" data-testid={`payment-input-${k}`} />
          </label>
        ))}
        <button disabled={busy} className="btn-gold justify-center py-3.5" data-testid="payment-save-button">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Save payment details"}
        </button>
      </div>
    </form>
  );
};
